(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      // Use DOMParser instead of innerHTML to safely parse the response
      var parser = new DOMParser();
      var doc = parser.parseFromString(request.response, 'text/html');
      
      // Find the related-products section in the parsed response
      var newRelatedProducts = doc.querySelector(".related-products");
      
      if (newRelatedProducts) {
        // Clear the existing content
        productRecommendationsSection.innerHTML = '';
        
        // Safely copy over the attributes from the new section
        var attributes = newRelatedProducts.attributes;
        for (var i = 0; i < attributes.length; i++) {
          productRecommendationsSection.setAttribute(attributes[i].name, attributes[i].value);
        }
        
        // Safely copy over the children (the actual content)
        while (newRelatedProducts.firstChild) {
          productRecommendationsSection.appendChild(newRelatedProducts.firstChild);
        }
      }
    }
  };
  request.send();
};

// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
